import { render, staticRenderFns } from "./BSurveyModal.vue?vue&type=template&id=ca31cec2&"
import script from "./BSurveyModal.vue?vue&type=script&lang=js&"
export * from "./BSurveyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports